<template>
  <q-panel :header-text="listStructure.caption">
    <div class="q-toolbar">
      <div class="q-toolbar-buttons">
        <q-button
          class="q-toolbar-btn"
          :style="firstButtonStyle"
          @click="newModel"
        >
          <font-awesome-icon :icon="['fas', 'plus']" />
        </q-button>
        <q-button
          v-show="hasSelection"
          class="q-toolbar-btn"
          @click="deleteDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'trash']" />
        </q-button>

        <q-button
          class="q-toolbar-btn"
          @click.prevent="limitationDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'filter']" />
        </q-button>
        <q-button
          class="q-toolbar-btn"
          @click="refreshRows"
        >
          <font-awesome-icon :icon="['fas', 'sync-alt']" />
        </q-button>
        <q-divider direction="vertical" />
        <q-button
          class="q-toolbar-btn"
          @click.prevent="structureDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'cog']" />
        </q-button>
        <q-divider direction="vertical" />
        <a
          id="downloadAnchorElem"
          style="display:none"
        />
        <q-button
          class="q-toolbar-btn"
          @click.prevent="exportDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'upload']" />
        </q-button>
        <q-button
          class="q-toolbar-btn"
          @click.prevent="importDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'download']" />
        </q-button>
        <q-divider direction="vertical" />

        <q-dropdown
          v-show="hasSelection"
          trigger="click"
          class="q-toolbar-btn"
          @command="runMethods"
        >
          <q-button>
            <span>{{ this.$qt("listStructure.actionCaption") }}</span>
            <i class="q-icon-arrow-down q-icon--right" />
          </q-button>
          <q-dropdown-menu slot="dropdown">
            <q-dropdown-item
              v-for="method in listStructure.methods"
              :key="method.key"
              :command="method"
            >
              {{ method.caption }}
            </q-dropdown-item>
          </q-dropdown-menu>
        </q-dropdown>
        <q-dropdown
          trigger="click"
          class="q-toolbar-btn"
          @command="createReport"
        >
          <q-button>
            <font-awesome-icon :icon="['fas', 'chart-bar']" />
          </q-button>
          <q-dropdown-menu slot="dropdown">
            <q-dropdown-item
              v-for="report in listStructure.reports"
              :key="report.key"
              :command="report"
            >
              {{ report.caption }}
            </q-dropdown-item>
          </q-dropdown-menu>
        </q-dropdown>

        <q-input
          v-model="word"
          :placeholder="this.$qt('listStructure.searchPlaceHolder')"
          :style="searchStyle"
        >
          <q-button
            slot="append"
            type="info"
            icon="q-icon-search"
          />
        </q-input>
      </div>
    </div>

    <!--<q-panel>-->
    <q-table
      stripe
      :data="filteredData"
      :width="listStructure.width"
      sum-text="----"
      :empty-text="this.$qt('listStructure.emptyList')"
      @row-click="rowSelected"
      @selection-change="handleSelectionChange"
    >
      <q-table-column
        type="selection"
        width="55"
      />
      <q-table-column
        label=""
        width="40"
      >
        <template slot-scope="scope">
          <router-link
            :to="{
              name: 'detail',
              params: {
                structureKey: listStructure.detailFormKey,
                modelId: scope.row['id'],
              },
            }"
          >
            <font-awesome-icon icon="edit" />
          </router-link>
        </template>
      </q-table-column>
      <q-table-column
        v-for="col in listStructure.columns"
        :key="col.key"
        :type="col.type"
        :sortable="col.sortable === true"
        :label="col.caption"
        :width="col.width === 0 ? undefined : col.width"
      >
        <template slot-scope="scope">
          <template v-if="col.fieldType === 'DatePicker'">
            <span style="direction: ltr">{{ scope.row[col.key] }}</span>
          </template>
          <template v-else-if="col.fieldType === 'CheckBox'">
            <font-awesome-icon
              v-if="scope.row[col.key] === true"
              icon="check"
            />
            <font-awesome-icon
              v-else
              icon="times"
            />
          </template>
          <template v-else-if="col.fieldType === 'model'">
            <span>AMIN</span>
          </template>
          <template v-else>
            <span>{{ scope.row[col.key] }}</span>
          </template>
        </template>
      </q-table-column>
    </q-table>

    <q-pagination
      :page-size="listStructure.itemInPage"
      :pager-count="13"
      :total="modelsQty"
      layout="prev ,pager , next"
      :current-page.sync="currentPage"
      :next-text="this.$qt('listStructure.pagination.nextText')"
      :prev-text="this.$qt('listStructure.pagination.prevText')"
      background
      @current-change="changePage"
    />
    <!--</q-panel>-->

    <q-dialog
      :title="this.$qt('listStructure.settingTitle')"
      width="50%"
      :visible.sync="structureDialog"
    >
      <list-structure-detail
        v-model="listStructure"
        @close="structureDialog = false"
      />
    </q-dialog>

    <q-dialog
      :title="this.$qt('listStructure.limitationTitle')"
      width="50%"
      :visible.sync="limitationDialog"
      :close-on-press-escape="false"
      :close-on-click-modal:="false"
      append-to-body
    >
      <div v-if="limitationStructure">
        <q-form
          ref="limitationForm"
          :model="rangeModel"
          :rules="rangeRules"
          labq-width="150px"
        >
          <q-form-generator
            v-model="rangeModel"
            :form-structure="limitationStructure"
          />
        </q-form>
      </div>
      <div v-else>
        <span>{{ this.$qt("listStructure.limitationNotSet") }}</span>
      </div>

      <span slot="footer">
        <q-button
          type="primary"
          @click="limit"
        >{{
          this.$qt("listStructure.confirmLimitation")
        }}</q-button>
        <q-button @click="limitationDialog = false">{{
          this.$qt("listStructure.rejectLimitation")
        }}</q-button>
      </span>
    </q-dialog>

    <q-dialog
      :title="this.$qt('model.deleteDialog.title')"
      :visible.sync="deleteDialog"
      width="30%"
      append-to-body
    >
      <span>{{ this.$qt("model.deleteDialog.warningNote") }}</span>
      <span slot="footer">
        <q-button
          type="primary"
          @click="deleteModel()"
        >
          {{ this.$qt("model.deleteDialog.confirm") }}
        </q-button>
        <q-button @click="deleteDialog = false">
          {{ this.$qt("model.deleteDialog.cancel") }}
        </q-button>
      </span>
    </q-dialog>

    <q-dialog
      :title="this.$qt('listStructure.importDialogTitle')"
      width="50%"
      :visible.sync="importDialog"
      append-to-body
    >
      <div>
        <h3>IMPORT DIALOG m</h3>
        <q-form
          ref="importForm"
          :model="importModel"
          :rules="importModelRules"
          labq-width="150px"
        >
          <q-form-item
            :label="this.$qt('listStructure.selectFileForImport')"
            prop="modelsFile"
          >
            <q-upload
              v-model="importModel.models"
              type="json"
            />

            <q-json>{{ importModel }}</q-json>
          </q-form-item>
        </q-form>
      </div>

      <span slot="footer">
        <q-button
          type="primary"
          @click="importModels()"
        >
          {{ this.$qt("listStructure.importButton") }}
        </q-button>
        <q-button @click="importDialog = false">
          {{ this.$qt("listStructure.rejectLimitation") }}
        </q-button>
      </span>
    </q-dialog>

    <q-dialog
      :title="this.$qt('listStructure.exportDialogTitle')"
      width="50%"
      :visible.sync="exportDialog"
      append-to-body
    >
      <q-form
        ref="limitationForm"
        :model="exportSetting"
        labq-width="150px"
      >
        <q-form-item prop="removeId">
          <q-checkbox v-model="exportSetting.removeId">
            <span>{{ this.$qt("listStructure.exportSetting.removeIdTitle") }}</span>
          </q-checkbox>
        </q-form-item>
      </q-form>

      <span slot="footer">
        <q-button
          type="primary"
          @click="exportModels()"
        >
          {{ this.$qt("listStructure.exportButton") }}
        </q-button>
        <q-button @click="exportDialog = false">
          {{ this.$qt("listStructure.rejectLimitation") }}
        </q-button>
      </span>
    </q-dialog>
  </q-panel>
</template>

<script>
import reportMixin from "./reportMixin";
import listMixin from "../../../q-components/mixins/listMixin";
import caller from "../../../q-components/q-caller";
import listStructureDetail from "../structures/listStructureDetail";
// import format from "../../../q-components/q-local/format";

export default {
  name: "QModelList",

  components: {
    "list-structure-detail": listStructureDetail,
    // 'table-generator': tableGenerator,
    // 'chart-generator': chartGenerator
  },

  mixins: [listMixin, reportMixin],
  props: {
    structureKey: { required: true, type: String },
  },

  data() {
    return {
      limitationDialog: false,
      limitationStructure: undefined,
      importDialog: false,
      exportDialog: false,
      exportSetting: {},
      importModel: {},
      importModelRules: {},
      rangeModel: {},
    };
  },

  methods: {
    initialize(structureKey) {
      caller
        .delegate("structure", "fetchListStructure", {
          structureKey: structureKey,
        })
        .then((structureResponse) => {
          this.models = [];
          this.pageQty = 0;
          this.modelsQty = 0;
          this.listStructure = structureResponse.result;
          this.rangeModel = {};
          this.currentPage = 1;
          this.fetchModels();
          this.initializeLimitation();
        })
        .catch(() => {});
    },

    fetchModels() {
      if (this.listStructure.delegate) {
        caller
          .delegate(this.listStructure.plugin, this.listStructure.delegate, {
            range: this.rangeModel,
            itemInPage: this.listStructure.itemInPage,
            page: this.currentPage,
          })
          .then((res) => {
            this.models = res.result.models;
            this.pageQty = res.result.pageQty;
            this.modelsQty = res.result.itemsQty;
            this.limitationDialog = false;
          });
      } else {
        caller
          .service(
            this.listStructure.plugin,
            this.listStructure.model,
            this.listStructure.method,
            {
              range: this.rangeModel,
              itemInPage: this.listStructure.itemInPage,
              page: this.currentPage,
            }
          )
          .then((res) => {
            this.models = res.result.models;
            this.pageQty = res.result.pageQty;
            this.modelsQty = res.result.itemsQty;
            this.limitationDialog = false;
          });
      }
    },

    initializeLimitation() {
      console.log(this.listStructure.key + "Limitation");
      this.$delegate("structure", "fetchFormStructure", {
        structureKey: this.listStructure.key + "Limitation",
      })
        .then((response) => {
          this.limitationStructure = response.result;
        })
        .catch(() => {});

      this.$eventHub.$emit("onPageChanging", {
        caption: this.listStructure.caption,
        note: this.listStructure.note,
      });
    },

    refreshRows() {
      this.models = [];
      this.pageQty = 0;
      this.modelsQty = 0;
      this.rangeModel = {};
      this.fetchModels();
    },
    limit() {
      this.models = [];
      this.fetchModels();
    },
    changePage() {
      this.fetchModels();
    },
    rowSelected(row) {
      let params = {
        structureKey: this.listStructure.detailFormKey,
        modelId: row.id,
      };
      this.$router.push({ name: "detail", params: params });
    },
    newModel() {
      let params = {
        structureKey: this.listStructure.detailFormKey,
        modelId: "NEW",
      };
      this.$router.push({
        name: "detail",
        params: params,
      });
    },
    deleteModel() {
      this.$service(
        this.listStructure.plugin,
        this.listStructure.model,
        "delete",
        {
          selectedModels: this.multipleSelection,
        }
      )
        .then((res) => {
          this.$notify({
            title: this.$qt("model.deleteDialog.successMessage"),
            message: res.message,
            type: "success",
          });
          this.deleteDialog = false;

          this.multipleSelection.forEach((item) => {
            const index = this.models.findIndex((d) => d.id === item.id);
            this.models.splice(index, 1);
          });
        })
        .catch(() => {});
    },

    runMethods(method) {
      this.$delegate(method.plugin, method.delegate, {
        models: this.multipleSelection,
      })
        .then((res) => {
          this.$notify({
            title: this.$qt("listStructure.methodSuccessTitle"),
            message: res.message,
            type: "success",
          });
        })
        .catch(() => {});
    },

    exportModels() {
      this.$service(
        this.listStructure.plugin,
        this.listStructure.model,
        "exportModels",
        {
          range: this.rangeModel,
          removeId: this.exportSetting.removeId,
        }
      )
        .then((res) => {
          this.exportDialog = false;
          let modelList = res.result.models;
          let dataStr =
            "data:text/json;charset=utf-8," +
            encodeURIComponent(JSON.stringify(modelList));
          let dlAnchorElem = document.getElementById("downloadAnchorElem");
          dlAnchorElem.setAttribute("href", dataStr);
          dlAnchorElem.setAttribute(
            "download",
            this.listStructure.key + ".json"
          );
          dlAnchorElem.click();
          this.$notify({
            title: this.$qt("model.xxx"),
            message: res.message,
            type: "success",
          });
        })
        .catch(() => {});
    },
    importModels() {
      this.$service(
        this.listStructure.plugin,
        this.listStructure.model,
        "importModels",
        {
          models: this.importModel.models,
        }
      )
        .then((res) => {
          this.importDialog = false;
          this.$notify({
            title: this.$qt("model.successPersistTitle"),
            // message: result.message.message,
            message: res.message,
            type: "success",
          });
        })
        .catch(() => {});
    },
  },

  beforeRouteUpdate(to, from, next) {
    this.initialize(to.params.structureKey);
    next((vm) => vm.initialize(to.params.structureKey));
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => vm.initialize(to.params.structureKey));
  },
};
</script>

<style scoped>
.q-toolbar {
  margin: 20px;
}

.q-toolbar-buttons {
  display: -webkit-box;
  display: -ms-flexbox;

  display: flex;
  line-height: 15px;
}

.q-toolbar-btn {
  margin-left: 3px;
  margin-right: 3px;
}
</style>
